// Will return true if:
// (1) the promo code doesn't have allowed_airline_carriers
// (2) the promo code has allowed_airline_carriers and cart has validatingCarrier with airline code in promo code allowed carrier codes
export default function verifyAirlineCarrier(promo: App.Promotion, cart: App.CartState): boolean {
  if (!promo.allowedAirlineCarriers || promo.allowedAirlineCarriers?.length === 0) {
    return true
  }
  const validatingCarrier = cart.flight.journey.validatingCarrier
  return (promo.allowedAirlineCarriers.includes(validatingCarrier) && promo.type === 'fixed_amount')
}
